// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/common/source_application.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "squareup.connect.v2.common";
/**
 * --
 * @desc Indicates the Square product used to generate a change.
 * --
 */
export var Product;
(function (Product) {
    Product[Product["PRODUCT_DO_NOT_USE"] = -1] = "PRODUCT_DO_NOT_USE";
    /** SQUARE_POS - @desc Square Point of Sale application. */
    Product[Product["SQUARE_POS"] = 0] = "SQUARE_POS";
    /** EXTERNAL_API - @desc Square Connect APIs (for example, Orders API or Checkout API). */
    Product[Product["EXTERNAL_API"] = 1] = "EXTERNAL_API";
    /** BILLING - @desc A Square subscription (various products). */
    Product[Product["BILLING"] = 2] = "BILLING";
    /** APPOINTMENTS - @desc Square Appointments. */
    Product[Product["APPOINTMENTS"] = 3] = "APPOINTMENTS";
    /** INVOICES - @desc Square Invoices. */
    Product[Product["INVOICES"] = 4] = "INVOICES";
    /** ONLINE_STORE - @desc Square Online Store. */
    Product[Product["ONLINE_STORE"] = 5] = "ONLINE_STORE";
    /** PAYROLL - @desc Square Payroll. */
    Product[Product["PAYROLL"] = 6] = "PAYROLL";
    /** DASHBOARD - @desc Square Dashboard. */
    Product[Product["DASHBOARD"] = 8] = "DASHBOARD";
    /** ITEM_LIBRARY_IMPORT - @desc Item Library Import. */
    Product[Product["ITEM_LIBRARY_IMPORT"] = 9] = "ITEM_LIBRARY_IMPORT";
    /** RETAIL - @desc Square Retail. */
    Product[Product["RETAIL"] = 10] = "RETAIL";
    /** RESTAURANT - @desc Square Restaurant. */
    Product[Product["RESTAURANT"] = 11] = "RESTAURANT";
    /** CUSTOMERS_DIRECTORY - @desc Square Customers. */
    Product[Product["CUSTOMERS_DIRECTORY"] = 12] = "CUSTOMERS_DIRECTORY";
    /** CHANNELS - @desc Square Channels */
    Product[Product["CHANNELS"] = 13] = "CHANNELS";
    /** OTHER - @desc A Square product that does not match any other value. */
    Product[Product["OTHER"] = 7] = "OTHER";
})(Product || (Product = {}));
function createBaseSourceApplication() {
    return {
        $type: "squareup.connect.v2.common.SourceApplication",
        product: undefined,
        applicationId: undefined,
        name: undefined,
    };
}
export const SourceApplication = {
    $type: "squareup.connect.v2.common.SourceApplication",
    encode(message, writer = _m0.Writer.create()) {
        if (message.product !== undefined) {
            writer.uint32(8).int32(message.product);
        }
        if (message.applicationId !== undefined) {
            writer.uint32(18).string(message.applicationId);
        }
        if (message.name !== undefined) {
            writer.uint32(26).string(message.name);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSourceApplication();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.product = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.applicationId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return SourceApplication.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSourceApplication();
        message.product = object.product ?? undefined;
        message.applicationId = object.applicationId ?? undefined;
        message.name = object.name ?? undefined;
        return message;
    },
};
